exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App_app__3BT4Y {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  height: 100%;\n  background-color: #393939; }\n  .App_app__3BT4Y .App_workspace__G_qXx {\n    flex: 1 1; }\n    .App_app__3BT4Y .App_workspace__G_qXx .App_visualization_viewer__3ph_N {\n      background-color: #242424; }\n  .App_app__3BT4Y .App_toast_container__3cY54 {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    z-index: 99; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"app": "App_app__3BT4Y",
	"workspace": "App_workspace__G_qXx",
	"visualization_viewer": "App_visualization_viewer__3ph_N",
	"toast_container": "App_toast_container__3cY54"
};